import { render } from "./back.svg?vue&type=template&id=455a6d30"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "455a6d30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('455a6d30', script)) {
    api.reload('455a6d30', script)
  }
  
  module.hot.accept("./back.svg?vue&type=template&id=455a6d30", () => {
    api.rerender('455a6d30', render)
  })

}

script.__file = "src/assets/icon/back.svg"

export default script